import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-payment-redirect',
    templateUrl: './payment-redirect.component.html',
    styleUrl: './payment-redirect.component.scss',
    standalone: false
})
export class PaymentRedirectComponent implements OnInit {
  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    const sessionId = this.route.snapshot.queryParamMap.get('session_id');

    setTimeout(() => {
      this.router.navigate(['/billing'], { queryParams: { session_id: sessionId } });
    }, 2000);
  }
}
